class ProductMedia extends HTMLElement {
  constructor() {
    super();
    
    this.index = this.dataset.index;
    this.lightbox = document.querySelector('product-lightbox');
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }
  
  handleClick() {
    this.lightbox.open(this.index);
  }
}

if (!customElements.get('product-media'))
  customElements.define('product-media', ProductMedia)

class ProductLightbox extends HTMLElement {
  constructor() {
    super();
    
    this.modalClose = this.querySelector('.product-lightbox__close');
    this.carousel = this.querySelector('.product-lightbox__carousel');
  }

  connectedCallback() {
    if(!this.carousel) return;

    this.modalClose.addEventListener('click', this.close.bind(this));
    this.initCarousel()

    document.body.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        this.close()
      }
    })
  }

  open(index) {
    this.carousel.swiper.slideTo(index, 0);
    this.toggleAttribute('opened', true);
  }

  close() {
    this.toggleAttribute('opened', false);
  }

  initCarousel() {

    Object.assign(this.carousel, {
      mousewheel: {
        enabled: true,
        forceToAxis:true,
      },
      pagination: {
        el: '.product-lightbox__pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.product-lightbox__carousel-nav .carousel-navigation__next',
        prevEl: '.product-lightbox__carousel-nav .carousel-navigation__prev'
      },
    });
    
    this.carousel.initialize();
  }
}

if (!customElements.get('product-lightbox'))
  customElements.define('product-lightbox', ProductLightbox)